import { Navigate, useLocation, Routes } from "react-router-dom"
import { RoleName } from "../features/auth/types"
import { useAuthState } from "../features/auth/hooks/useAuthState"

type RecruiterRoutesProps = {
  children: React.ReactNode
}

export default function RecruiterRoutes({ children }: RecruiterRoutesProps) {
  const { user } = useAuthState()
  const location = useLocation()

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (
    !user.roles?.some(
      (role) =>
        role.roleId === RoleName.Recruiter ||
        role.roleId === RoleName.Admin ||
        role.roleId === RoleName.SiteAdmin,
    )
  ) {
    return <Navigate to="/dashboard" replace />
  }

  return <Routes>{children}</Routes>
}
